import { Navigate } from 'react-router';
import { SectionNavLayout, wideScreen } from '../components/SectionNavLayout';
import { groupSections, searchSections, useSetupSections } from '../setupSections';

/**
 * Rahmen der Einrichtung (KON-105, KON-106). Links steht immer die Navigation mit Suche, die Bereiche nach fachlichen Gruppen. Anfangs ist nur „Allgemein“ offen.
 * Das Verhalten der Navigation steckt in SectionNavLayout, „Mein Konto“ nutzt dieselbe.
 */
export function SetupLayout() {
  const sections = useSetupSections();
  return (
    <SectionNavLayout
      title="Einrichtung"
      basePath="/einrichtung"
      groupsFor={(query) => groupSections(searchSections(sections, query)).map((g) => ({ key: g.key, label: g.label, links: g.sections }))}
      storageKey="kontor:setup-open:v2"
      defaultOpen={[]}
      navLabel="Bereiche der Einrichtung"
      searchLabel="Einstellung suchen"
      backLabel="Alle Bereiche der Einrichtung"
      empty={
        <div className="card narrow">
          <h1>Einrichtung</h1>
          <p className="muted">Ihre Rolle hat keinen Zugriff auf diesen Bereich.</p>
        </div>
      }
    />
  );
}

/** /einrichtung: Auf breiten Bildschirmen geht es gleich zum ersten Bereich, auf schmalen steht dort nur die Navigation */
export function SetupIndex() {
  const sections = useSetupSections();
  return wideScreen() && sections[0] ? <Navigate to={sections[0].path} replace /> : null;
}
